<template>
  <div id="module-container">
    <div id="module-left">
      <i id="module-container-thumb" :class="thumb === 1 ? 'iconfont el-icon-ipf-right thumb' : 'iconfont el-icon-ipf-left thumb'"
         :title="thumb === 1 ? '展开菜单栏' : '折叠菜单栏'" @click="setThumb"></i>
      {{date}}
    </div>
    <div id="module">
      <template v-for="menu in menus" v-if="filterMenu(menu)">
        <div :key="menu.id" class="item" :class="{'selected':selectedId === menu.id}" @click="jump(menu)">
          {{ menu.name }}
        </div>
      </template>
    </div>
    <div id="module-right">
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
  import * as config from '../../core/config'
  import * as layout from '../../core/layout'

  export default {
    name: 'NavModule',
    props: {
      menus: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        selectedId: '',
        date: layout.getDate()
      }
    },
    computed: {
      thumb: function () {
        return this.$store.state.session.thumb
      }
    },
    watch: {
      menus: {
        immediate: true,
        handler (nv) {
          if (config.layout === 1 && this.menus.length > 0) {
            if (this.$store.state.session.module && this.$store.state.session.module.id) {
              this.jump(this.$store.state.session.module)
            } else {
              this.jump(this.menus[0])
            }
          }
        }
      }
    },
    methods: {
      setThumb () {
        this.$store.dispatch('setSessionThumb', (this.$store.state.session.thumb === 1 ? 0 : 1))
      },
      filterMenu (menu) {
        if (config.layout === 1 && menu.pid === '-1') {
          return true
        }
        return false
      },
      jump (menu) {
        // 设置当前选中模块ID
        this.selectedId = menu.id
        // 告知当前模块被切换
        this.$emit('setModule', menu)
      }
    }
  }
</script>
